export enum FormDisplayMode {
  CONVERSATIONAL = 'conversational',
  REGULAR = 'regular',
}
